// extracted by css-extract-rspack-plugin
export default {"BrandCircle":"QuestionInfoSidebar-module__BrandCircle___Zcroh","IconMargin":"QuestionInfoSidebar-module__IconMargin___N1OW3"};